import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  background: {
    backgroundImage: "linear-gradient(rgba(35, 37, 41, 0.6), rgba(35, 37, 41, 0.6)), url('/images/contact/backgroundContact.jpg')",
    backgroundColor: "#7fc7d9", // Average color of the background image.
    backgroundPosition: "center",
    fontFamily: "Century-Gothic",
    fontSize: "calc(10px + 2vmin) !important",
  },
  title: {
    color: "white",
    fontFamily: "Century-Gothic",
    fontWeight: "bold",
    marginTop: theme.spacing(15),
  },
  h5: {
    color: "white",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(6),
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(10),
    },
  },
  arrowIcon: {
    pointerEvents: 'none', 
    color: "white",
    fontSize: 75,
    marginTop: theme.spacing(5),
    [theme.breakpoints.up("sm")]: {
      fontSize: 90,
      marginTop: theme.spacing(20),
    },
  },
}));
export default useStyles;
